export default __webpack_public_path__ + "static/media/vippeloft_Page_2.2fea55a4.png";